import React, { useEffect, useState, Fragment, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import { useAuth } from '../../../Context/Auth/AuthContext';

import { IoIosNotificationsOutline } from 'react-icons/io';

import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    Button,
    Container,
} from 'reactstrap';

import { faHome, faSync } from '@fortawesome/free-solid-svg-icons';

import {
    VerticalTimeline,
    VerticalTimelineElement,
} from 'react-vertical-timeline-component';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import city3 from '../../../assets/utils/images/dropdown-header/city3.jpg';

import PerfectScrollbar from 'react-perfect-scrollbar';
import NotificationStatuses from '../../../enums/NotificationStatuses';
import { toast } from 'react-toastify';
import classnames from 'classnames';

export default function HeaderDots() {
    const [notifications, setNotifications] = useState({});
    const [unread, setUnread] = useState(false);
    const { authenticated } = useAuth();
    const location = useLocation();
    const [isRefreshing, setIsRefreshing] = useState(false);

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    const listUserNotifications = useCallback(() => {
        setIsRefreshing(true);
        api.get(`/ro.team.listUserNotifications`)
            .then((response) => {
                setNotifications(response.data);
                
                const lastItemId = localStorage.getItem('@ReachOut_LastNotification');
                if (lastItemId !== undefined && response.data.results.length > 0 && response.data.results[0].id === lastItemId) {
                    setUnread(false);
                } else {
                    setUnread(response.data.unread > 0);
                }
            })
            .finally(() => {
                setIsRefreshing(false);
            });
    }, [setUnread]);

    useEffect(() => {
        listUserNotifications();
    }, [listUserNotifications]);

    const updateNotification = useCallback(async ({ notification }) => {
        await api
            .patch(`/ro.team.markNotificationAsRead/${notification.id}`)
            .then((response) => {
                // Setting local info to avoid refresh
                let newNotifications = [];
                notifications.results.forEach((item) => {
                    if (item.id === notification.id) {
                        item.status.code = 3;
                    }
                    newNotifications.push(item);
                });
                setNotifications({...notifications, results: newNotifications});
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [notifications, setNotifications]);

    const onSubmitAccept = useCallback(async (notification) => {
        await api
            .post(`/ro.team.acceptInvite/${notification.token}`, {
                name: notification.user.name,
                email: userInfo().email
            })
            .then((response) => {
                updateNotification({ notification });
                // history.push('/groups');
                toast.success('Your invitation has been confirmed. Enjoy!');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [userInfo, updateNotification]);

    const onSubmitRefuse = useCallback(async (notification) => {
        await api
            .get(`/ro.team.refuseInvite/${notification.token}`)
            .then((response) => {
                updateNotification({ notification });
                // history.push('/groups');
                toast.success('Your invitation has been declined.');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [updateNotification]);

    const saveReadNotificationLocal = useCallback(() => {
        if (unread) {
            const lastItemId = notifications.results[0].id;
            localStorage.setItem('@ReachOut_LastNotification', lastItemId);
            setUnread(false);
        }        
    }, [unread, setUnread, notifications]);

    const refreshNotifications = useCallback(() => {
        listUserNotifications();
    }, [listUserNotifications]);

    return (
        <Fragment>
            <div className="header-dots">
                <Link to="/groups">
                    <div className="icon-wrapper icon-wrapper-alt rounded-circle">
                        <div
                            className={classnames(
                                'icon-wrapper-bg bg-primary',
                                {
                                    'opacity-3':
                                        location.pathname === '/groups',
                                }
                            )}
                        />
                        <FontAwesomeIcon icon={faHome} size="1x" />
                    </div>
                </Link>
                <UncontrolledDropdown
                    onClick={() => {
                        saveReadNotificationLocal();
                    }}
                >
                    <DropdownToggle
                        className="p-0 mr-2"
                        color="link"
                    >
                        <div className="icon-wrapper icon-wrapper-alt rounded-circle">
                            <div className="icon-wrapper-bg bg-danger" />
                            <IoIosNotificationsOutline
                                color="#d92550"
                                fontSize="23px"
                            />
                            {unread && (
                                <div className="badge badge-dot badge-dot-sm badge-danger">
                                    Notifications 
                                </div>
                            )}
                        </div>
                    </DropdownToggle>
                    <DropdownMenu
                        right
                        className="dropdown-menu-xl rm-pointers"
                    >
                        <div className="dropdown-menu-header mb-0">
                            <div className="dropdown-menu-header-inner bg-deep-blue">
                                <div
                                    className="menu-header-image opacity-1"
                                    style={{
                                        backgroundImage: 'url(' + city3 + ')',
                                    }}
                                />
                                <div className="menu-header-content text-dark">
                                    <h5 className="menu-header-title">
                                        Notifications
                                    </h5>
                                    {/* <h6 className="menu-header-subtitle">
                                        You have <b>{notifications.unread}</b>{' '}
                                        unread messages
                                    </h6> */}
                                </div>
                            </div>
                        </div>
                        
                        <Container>
                            {notifications.results && notifications.results.length > 0 && (
                                
                                <PerfectScrollbar
                                    style={{ maxHeight: '250px' }}
                                >
                                    <VerticalTimeline layout="1-column">
                                        {notifications &&
                                            notifications.results &&
                                            notifications.results.map(
                                                (item) => (
                                                    <VerticalTimelineElement
                                                        key={item.id}
                                                        className="vertical-timeline-item"
                                                        icon={
                                                            <i
                                                                className={`badge badge-dot badge-dot-xl badge-${
                                                                    item.status
                                                                        .code ===
                                                                    JSON.parse(
                                                                        NotificationStatuses.UNREAD
                                                                    )
                                                                        ? 'success'
                                                                        : 'success'
                                                                }`}
                                                            >
                                                                {' '}
                                                            </i>
                                                        }
                                                        date={item.time}
                                                    >
                                                        <div>
                                                            <h4 className="timeline-title">
                                                                {item.title}
                                                            </h4>
                                                            <p className="timeline-title">
                                                                {item.content}
                                                                {/* <div className="badge badge-secondary ml-1">
                                                            Mark as read
                                                        </div> */}
                                                            </p>
                                                            {item.type === 2 && item.status.code !== 3 && (
                                                                <div>
                                                                    <Button
                                                                        className="mb-2 mr-2 btn-icon btn-pill"
                                                                        color="primary"
                                                                        onClick={() =>
                                                                            onSubmitAccept(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="lnr-thumbs-up btn-icon-wrapper">
                                                                            {' '}
                                                                        </i>
                                                                    </Button>
                                                                    <Button
                                                                        className="mb-2 mr-2 btn-icon btn-pill"
                                                                        color="danger"
                                                                        onClick={() =>
                                                                            onSubmitRefuse(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="lnr-thumbs-down btn-icon-wrapper">
                                                                            {' '}
                                                                        </i>
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </VerticalTimelineElement>
                                                )
                                            )}
                                    </VerticalTimeline>
                                </PerfectScrollbar>
                            )}

                            {notifications && notifications.results && notifications.results.length === 0 && (
                                <div className="mt-2 mb-2">
                                    There is nothing here
                                </div>
                            )}

                            <div className="text-center">
                                <Button
                                    outline
                                    className="mb-2 mr-2"
                                    color="secondary"
                                    onClick={refreshNotifications}
                                    disabled={isRefreshing}
                                >
                                    Refresh <FontAwesomeIcon icon={faSync} spin={isRefreshing} size="1x" />
                                </Button>
                                
                            </div>

                        </Container>
                        
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        </Fragment>
    );
}
